import { useState, useEffect } from "react";
import { flushPendingToastFromStorage, toastService, type Toast } from "./toast.service";
import { Toast as ToastComponent } from "./Toast";

export const ToastContainer = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    // After a full reload (e.g. Apple redirect), show any toast we persisted before navigation.
    flushPendingToastFromStorage();

    const unsubscribe = toastService.subscribe((newToasts) => {
      setToasts(newToasts);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        left: "20px",
        // Above shared Modal overlay (z-index 10050) so toasts stay visible in modals.
        zIndex: 11000,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        pointerEvents: "none",
      }}
    >
      {toasts.map((toast) => (
        <ToastComponent key={toast.id} toast={toast} onRemove={(id) => toastService.remove(id)} />
      ))}
    </div>
  );
};
